<div class="flex items-center justify-between">
  @if (label()) {
    <label
      class="mb-x-sm text-sm"
      [class.text-neutral-300]="disabled()"
      [class.cursor-not-allowed]="disabled()"
      [class.text-neutral-900]="!disabled()"
      [class.font-medium]="!disabled()"
      [class.label-required]="requiredEn() || requiredAr() || requiredGroup()"
      [for]="id()">
      {{ label() }}
    </label>
  } @else {
    <div class="mb-x-sm text-sm"></div>
  }
  <!-- Language Switch -->
  @if (!isSingleInput()) {
    <div
      class="flex items-center gap-sm lang-switch mb-x-sm"
      [class.cursor-not-allowed]="disabled()">
      <button
        type="button"
        class="lang-button text-xs"
        [class.active]="currentLang() === 'EN'"
        [class.has-error]="
          (childControlEn && childControlEn.touched && childControlEn.errors) ||
          (parentFormGroup.touched && parentFormGroup.errors)
        "
        [disabled]="disabled()"
        (click)="switchLanguage('EN')">
        EN
      </button>

      <button
        type="button"
        class="lang-button text-xs"
        [class.active]="currentLang() === 'AR'"
        [class.me-xl]="isHasToolTip()"
        [class.has-error]="
          (childControlAr && childControlAr.touched && childControlAr.errors) ||
          (parentFormGroup.touched && parentFormGroup.errors)
        "
        [disabled]="disabled()"
        (click)="switchLanguage('AR')">
        AR
      </button>
    </div>
  }
</div>

<div class="flex flex-col">
  <div>
    <!-- English Input -->
    <div class="relative flex items-center" [hidden]="currentLang() !== 'EN'">
      @if (startIcon()) {
        <div
          class="icon start-3"
          [class.opacity-30]="disabled()"
          [class.cursor-not-allowed]="disabled()">
          <img [src]="startIcon()" alt="start-icon" />
        </div>
      }

      <input
        [type]="type()"
        [id]="id() + '_en'"
        [readOnly]="readonly()"
        [formControlName]="isSingleInput() ? inputFormControlName() : 'en'"
        [required]="requiredEn()"
        [min]="min()"
        [max]="max()"
        [attr.minlength]="minlength()"
        [attr.maxlength]="maxlength()"
        [placeholder]="displayPlaceholderEn()"
        class="w-full border border-neutral-300 rounded-md shadow-xs text-sm text-neutral-900 ps-3 pe-3 h-[2.75rem]"
        [class]="inputClass()"
        [class.has-errors]="
          (childControlEn && childControlEn.touched && childControlEn.errors) ||
          (parentFormGroup.touched && parentFormGroup.errors)
        "
        [class.text-destructive-900]="
          (childControlEn && childControlEn.touched && childControlEn.errors) ||
          (parentFormGroup.touched && parentFormGroup.errors)
        "
        [class.text-neutral-300]="disabled()"
        [class.ps-5xl]="startIcon()"
        libTrim />
    </div>

    <!-- Arabic Input -->
    @if (!isSingleInput()) {
      <div class="relative flex items-center" [hidden]="currentLang() !== 'AR'">
        @if (startIcon()) {
          <div
            class="icon start-3"
            [class.opacity-30]="disabled()"
            [class.cursor-not-allowed]="disabled()">
            <img [src]="startIcon()" alt="start-icon" />
          </div>
        }

        <input
          [type]="type()"
          [id]="id() + '_ar'"
          [readOnly]="readonly()"
          [formControlName]="'ar'"
          [required]="requiredAr()"
          [min]="min()"
          [max]="max()"
          [attr.minlength]="minlength()"
          [attr.maxlength]="maxlength()"
          [placeholder]="displayPlaceholderAr()"
          class="w-full border border-neutral-300 rounded-md shadow-xs text-sm text-neutral-900 ps-md pe-md h-[2.75rem]"
          [class]="inputClass()"
          [class.has-errors]="
            (childControlAr &&
              childControlAr.touched &&
              childControlAr.errors) ||
            (parentFormGroup.touched && parentFormGroup.errors)
          "
          [class.text-destructive-900]="
            (childControlAr &&
              childControlAr.touched &&
              childControlAr.errors) ||
            (parentFormGroup.touched && parentFormGroup.errors)
          "
          [class.text-neutral-300]="disabled()"
          [class.ps-5xl]="startIcon()"
          libTrim />
      </div>
    }
  </div>

  <!-- Validation Messages -->
  <div>
    @if (!isSingleInput()) {
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        [control]="'en'"
        [isDualLang]="true"
        [requiredMessage]="requiredMessageEn()" />

      <lib-validation-message
        [lang]="'current_lang' | transloco"
        [control]="'ar'"
        [isDualLang]="true"
        [requiredMessage]="requiredMessageAr()" />
    } @else {
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        [control]="inputFormControlName()"
        [isDualLang]="true"
        [requiredMessage]="requiredMessageEn()" />
    }
  </div>
</div>
